import { PopulatedCalendarEvent } from "../api/calendarEvent";

const globalPriorityMap = {
  "Public Holiday": 1,
  "National holiday": 1,
  "Federal Holiday": 2,
  "Federal Public Holiday": 2,
  "National Holiday": 2,
  "Regular Holiday": 3,
  "Statutory Holiday": 3,
  "Bank holiday": 4,
  "Bank Holiday": 4,
  "Public holiday": 5,
  "Obligatory Holiday": 6,
  "Official Holiday": 7,
  "Official holiday": 7,
  "Gazetted Holiday": 8,
  "Joint Holiday": 9,
  "National/Legal Holiday": 10,
  "Public Sector Holiday": 11,
  "Public Sector": 11,
  "Legal Holiday": 12,
  "National Day": 13,
  "Substitute Holiday": 14,
  "State Holiday": 15,
  "Government Holiday": 16,
  "Government holiday": 16,
  "Common State holiday": 17,
  "Province/Territory Holiday": 18,
  "Statutory Province/Territory Holiday": 19,
  "Common Province/Territory Holiday": 20,
  "Regional Holiday": 21,
  "Regional holiday": 21,
  "Regional government holiday": 22,
  "Autonomous Community Holiday": 23,
  "District Holiday": 24,
  "Federal Territory Holiday": 25,
  "State Bank Holiday": 26,
  "Bank and government holiday": 27,
  "Bank/Public Sector Holiday": 28,
  "Bank / working holiday": 28,
  "De facto and Bank holiday": 29,
  "De Facto and Bank Holiday": 29,
  "State Legal Holiday": 30,
  "State Public Sector Holiday": 31,
  "Special Non-working Holiday": 32,
  "Special Working Day": 33,
  "Working Day on a Weekend": 34,
  "Working Day on weekend": 34,
  "Working day on weekend": 34,
  Observance: 41,
  "Worldwide observance": 42,
  "United Nations observance": 43,
  "Major Observance": 44,
  Season: 45,
  "Annual Monthly Observance": 46,
  "Optional Holiday": 47,
  "Optional holiday": 47,
  "Elective Holiday": 47,
  "Restricted Holiday": 48,
  "Restricted Trading Day": 49,
  "Non Compulsory Payment Holiday": 50,
  "Half Day Holiday": 51,
  "Half-day holiday": 51,
  "Half Day": 51,
  "Half day holiday": 51,
  "Half-day": 51,
  "Half Day Bank holiday": 52,
  "Suspended National Holiday": 53,
  "Official Holiday, Business as usual": 54,
  "Local holiday": 55,
  "Municipal Holiday": 56,
  "Municipal holiday": 56,
  "Common local holiday": 57,
  "De facto holiday": 58,
  "De Facto Holiday": 58,
  "Local de facto holiday": 59,
  "Half Day for Public Employees": 60,
  "Holiday for Public Employees": 61,
  "Federal Employees Holiday": 62,
  "Private Sector Holiday": 63,
  "Educational Holiday": 64,
  Christian: 71,
  Orthodox: 72,
  "Jewish holiday": 73,
  "Jewish Holiday": 73,
  Hebrew: 73,
  "Jewish commemoration": 74,
  "Jewish Commemoration": 74,
  Muslim: 75,
  "Hindu Holiday": 76,
  Hinduism: 76,
  "State Observance": 81,
  "Province/Territory Observance": 82,
  "Local observance": 83,
  "Local Observance": 83,
  "Silent Day": 84,
  "Flag day": 85,
  "Sporting event": 91,
};

export const DEFAULT_PRIORITY = 999;

export function getPriorityForType(primaryType: string | undefined): number {
  if (!primaryType) {
    return DEFAULT_PRIORITY;
  }
  return (
    (globalPriorityMap as Record<string, number>)[primaryType] ??
    DEFAULT_PRIORITY
  );
}

export function getPriorityColor(
  priority: number,
): "error" | "warning" | "info" | "success" | "default" {
  if (priority <= 15) return "error";
  if (priority <= 40) return "warning";
  if (priority <= 55) return "info";
  if (priority <= 70) return "success";
  return "default";
}

export function getPriorityTier(priority: number): string {
  if (priority <= 15) return "PRIMARY";
  if (priority <= 40) return "SECONDARY";
  if (priority <= 55) return "LOCAL";
  if (priority <= 70) return "OPTIONAL";
  if (priority <= 95) return "OBSERVANCE";
  return "OTHER";
}

export function groupEventsByCountry(events: PopulatedCalendarEvent[]): {
  [countryName: string]: PopulatedCalendarEvent[];
} {
  const grouped: { [countryName: string]: PopulatedCalendarEvent[] } = {};

  events.forEach((event) => {
    const countryName = event.country?.name || "Unknown";
    if (!grouped[countryName]) {
      grouped[countryName] = [];
    }
    grouped[countryName].push(event);
  });

  Object.keys(grouped).forEach((countryName) => {
    grouped[countryName].sort((a, b) => {
      const priorityA = getPriorityForType(a.primaryType);
      const priorityB = getPriorityForType(b.primaryType);
      return priorityA - priorityB;
    });
  });

  return grouped;
}

export function getPrioritizedEvents(
  events: PopulatedCalendarEvent[],
): PopulatedCalendarEvent[] {
  if (events.length === 0) return [];

  const lowestPriority = Math.min(
    ...events.map((e) => getPriorityForType(e.primaryType)),
  );

  return events.filter(
    (e) => getPriorityForType(e.primaryType) === lowestPriority,
  );
}
